module.exports = __webpack_public_path__ + "static/3-39c94c035c45e1f2a0b111746d0f55ce.jpg";